exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-622ae5d5]{margin:10px}.nowrap-text[data-v-622ae5d5]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-622ae5d5","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CheckoutFooter.vue
// module id = w61C
// module chunks = 0